<template>
  <div class="modalback">
    <div class="modalcontent row justify-content-center">
      <div class="close cursor-pointer"><img src="@/assets/acrypro/close.svg" @click="closeAction"/></div>
      <p class="fw-bold" style="font-size: 20px;">契約書</p>

      <div style="width:100px; height:30px;"></div>

      <p class="fw-bold m-0" style="font-size: 16px;">本サービスを使用するには契約書への署名が必要です。</p>
      <p class="fw-bold m-0" style="font-size: 16px;">{{getEmail}} 宛に署名依頼のメールを送信します。</p>
      <p class="fw-bold m-0 mb-4" style="font-size: 16px;">メールに記載されたURLをクリックして、契約を完了させてください。</p>

      <div class="memo">
        <p class="m-0 text-start" style="font-size: 14px;">・<span class="status-error-color">再送信を行う前に<span class="fw-bold">noreply@gmosign.com</span>からメールが届いているかご確認ください。</span></p>
        <p class="m-0 text-start" style="font-size: 14px;">・署名依頼のメールは<span class="fw-bold">noreply@gmosign.com</span>からお送りしています。</p>
        <p class="m-0 text-start" style="font-size: 14px;">・メールが届かない場合は、メールアドレスが間違っているか、迷惑メールフォルダに届いてしまっている可能性があります。</p>
      </div>

      <div class="row">
        <div class="col justify-content-center pt-4">
          <button class="acry-btn-primary-normal fw-bold btn-size" style="font-size: 20px;" @click="okAction">署名依頼の再送信</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { User } from "@/js/User.js";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "ResendContractDialog",
  props: {},
  data: function () {
    return {
    };
  },
  mounted: function () {
    // 画面の遷移があるか調べる
  },
  computed:{
    getEmail(){
      return firebase.auth().currentUser.email;
    }
  },
  methods: {
    async okAction(){
      let envelopeXID = null;
        await User.getFBAcryProUserData().then((data) => {
          if (data.envelopeXID) {
            envelopeXID = data.envelopeXID;
          }
        });
        if( envelopeXID ){
          // 契約書を再送信
          await User.resendRequest(envelopeXID).then(()=>{
            this.$store.commit("hideResendContractDialog");
            this.$store.commit("showMessage", "契約書を再送信しました");
          })
          .catch(()=>{
            this.$store.commit("hideResendContractDialog");
            this.$store.commit("showMessage", "エラーが発生しました")
          });
        }
    },
    closeAction(){
      this.$store.commit("hideResendContractDialog");
    }
  },
  components: {
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modalback {
  z-index: 200;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modalcontent {
  position: relative;
  z-index: 201;
  width: 800px;
  /* height: 200px; */
  padding: 40px;
  background-color: #FEFEFE;
  border-radius: 8px;
}
.close {
  position: absolute;
  width: 48px;
  right: 40px;
}
.memo{
  width: 600px;
  background: $background-gray-color;
  border-radius: 10px;
  padding: 14px;
  margin-top: 4px;
  margin-bottom: 10px;
}
</style>